export default "__VITE_ASSET__1PqTo7mE__"